module.exports = __webpack_public_path__ + "img/ar-tab-1.fbbb8172.png";